/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IOperandDropZoneInputScope extends IOperandScope {
        model: OperandDropZoneInputModel;
        onDragOver: ($event: any) => void;
        onDrop: ($event: any) => void;
        typedInValueChanged: () => void;
        getDisplayValue: () => string;
        enterTimeDuration: () => void;
    }

    export class OperandDropZoneInputModel {
        public typedInValue: string;
    }

    export class OperandDropZoneInput implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/operandDropZoneInput.html';
        public restrict: string = 'E';
        public controller = ['$scope', '$rootScope', 'calculationService', 'treeService', 'treeItemService', 'constantService', OperandDropZoneInputController];
        public controllerAs = 'controller';
        public scope: boolean = true; // False is use parents scope - True is create inherited scope from parents scope

        public link($scope: IOperandDropZoneInputScope, element: JQuery, attrs: ng.IAttributes, controller: OperandDropZoneInputController) { }
    }

    export class OperandDropZoneInputController implements IController {

        constructor(
            private $scope: IOperandDropZoneInputScope,
            private $rootScope: ng.IRootScopeService,
            private calculationService: services.CalculationService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            private constantService: services.ConstantService)
        {
            this.createConstantValue();

            this.$scope.model = new OperandDropZoneInputModel();

            this.setTypedInValue();
            
            // Public methods using lambdas to preserve this
            this.$scope.onDragOver = ($event: any) => this.onDragOverInternal($event);
            this.$scope.onDrop = ($event: any) => this.onDropInternal($event);
            this.$scope.typedInValueChanged = () => this.typedInValueChangedInternal();
            this.$scope.getDisplayValue = () => this.getDisplayValueInternal();
            this.$scope.enterTimeDuration = () => this.enterTimeDurationInternal();
        }

        private operandTypeChanged() {
            this.$rootScope.$broadcast('operand-type-changed');
        }

        private getOperand(): Wars.Domain.Model.Calculations.SimpleOperand {
            return <Wars.Domain.Model.Calculations.SimpleOperand>this.$scope.getOperation().operands[this.$scope.operandIndex];
        }

        private createConstantValue(): void {
            if (!this.getOperand().treeItem) {
                this.getOperand().treeItem = this.treeItemService.createTreeItem(this.$scope.isSystemLevel);
                this.getOperand().treeItem_id = this.getOperand().treeItem.id;
                this.getOperand().treeItem.itemSource = Wars.Domain.Model.Codes.Enums.TreeItemSource.Constant;
                this.getOperand().treeItem.isList = false;
                this.getOperand().treeItem.isClaimWithValue = false;
            }

            if (!this.getOperand().treeItem.constantValue) {
                this.getOperand().treeItem.constantValue = this.constantService.createConstant();
                this.getOperand().treeItem.constantValue_id = this.getOperand().treeItem.constantValue.id;
            }
        }

        private setTypedInValue(): void {
            switch (this.getOperand().treeItem.constantValue.variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                    this.$scope.model.typedInValue = this.getOperand().treeItem.constantValue.integerValue.toString();
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    this.$scope.model.typedInValue = this.getOperand().treeItem.constantValue.decimalValue.toString();
                    break;

                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                    this.$scope.model.typedInValue = this.getOperand().treeItem.constantValue.stringValue;
                    break;
            }
        }

        private enterTimeDurationInternal(): void {
            if (this.getOperand().treeItem) {
                if (this.calculationService.isTypedInConstant(this.getOperand().treeItem.constantValue)) {
                    this.getOperand().treeItem.constantValue.entityAspect.setDeleted();
                }
                this.getOperand().treeItem.entityAspect.setDeleted();
                this.getOperand().treeItem = null;
                this.getOperand().treeItem_id = null;
            }

            this.getOperand().isATimeDurationInput = true;
            var valueOperation = this.getOperand().parentValueOperation;
            valueOperation.variableType = services.CalculationService.getValueOperationVariableType(valueOperation);
        }

        private getDisplayValueInternal(): string {
            if (this.getOperand().treeItem == null || this.getOperand().treeItem.constantValue == null) return "";
            switch (this.getOperand().treeItem.constantValue.variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                    return this.getOperand().treeItem.constantValue.integerValue.toString();

                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    return this.getOperand().treeItem.constantValue.decimalValue.toString();

                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                    return this.getOperand().treeItem.constantValue.stringValue;
            }
            return "";
        }

        private canDrop(treeConfig: models.TreeConfigurationItem): boolean {
            if (this.$scope.allowableVariableTypes.length > 0) {
                return this.$scope.allowableVariableTypes.indexOf(treeConfig.variableType) !== -1;
            }
            return true;
        }

        private onDragOverInternal($event: any): void {
            // TODO: Do we want to do anything here?
        }

        private onDropInternal($event: any): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();
            if (!this.canDrop(treeConfig)) {
                alert("This item is not valid for this drop zone.");
                return;
            }

            if (this.getOperand().treeItem) {
                if (this.getOperand().treeItem.constantValue && this.calculationService.isTypedInConstant(this.getOperand().treeItem.constantValue))
                {
                    this.getOperand().treeItem.constantValue.entityAspect.setDeleted();
                }
                this.getOperand().treeItem.entityAspect.setDeleted();
            }
            var self = this;
            this.getOperand().treeItem = this.treeService.createTreeItemFromItemDropped(() => {
                this.getOperand().treeItem_id = this.getOperand().treeItem.id;
                self.operandTypeChanged();

                if (self.getOperand().treeItem.calculation_id) {
                    if (self.getOperand().treeItem.calculation.inputSchema && self.getOperand().treeItem.calculation.inputSchema.properties) {
                        for (let i = 0; i < self.getOperand().treeItem.calculation.inputSchema.properties.length; i++) {
                            self.createParameterEntities(self.getOperand().treeItem.calculation.inputSchema.properties[i]);
                        }
                    }
                }
            });

            var parentValueOperation = this.getOperand().parentValueOperation;
            parentValueOperation.variableType = services.CalculationService.getValueOperationVariableType(parentValueOperation);
            
            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }

        private createParameterEntities(property: Wars.Domain.Model.SchemaProperty) {
            // Create new Operation Parameter
            var newOperationParameter = this.calculationService.createNewOperationParameter(property);

            // Create Tree Item
            newOperationParameter.treeItem = this.treeItemService.createTreeItem(this.$scope.isSystemLevel);
            newOperationParameter.treeItem_id = newOperationParameter.treeItem.id;

            // Create new Constant Value
            newOperationParameter.treeItem.constantValue = this.constantService.createConstant();
            newOperationParameter.treeItem.constantValue_id = newOperationParameter.treeItem.constantValue.id;

            this.getOperand().parameters.push(newOperationParameter);
        }

        private typedInValueChangedInternal(): void {
            // Check for empty
            if (this.$scope.model.typedInValue.length === 0) {
                if (this.getOperand().treeItem && this.getOperand().treeItem.constantValue) {
                    this.getOperand().treeItem.constantValue.integerValue = undefined;
                    this.getOperand().treeItem.constantValue.decimalValue = undefined;
                    this.getOperand().treeItem.constantValue.stringValue = undefined;
                }
            } else {
                if (this.$scope.model.typedInValue.trim().length === 0) {
                    // Just whitespace
                    this.setStringConstantValue(this.$scope.model.typedInValue);
                }
                else if (this.isAnInt(this.$scope.model.typedInValue)) {
                    this.setIntConstantValue(parseInt(this.$scope.model.typedInValue));
                } else if (this.isAFloat(this.$scope.model.typedInValue)) {
                    this.setDecimalConstantValue(parseFloat(this.$scope.model.typedInValue));
                } else {
                    this.setStringConstantValue(this.$scope.model.typedInValue);
                }
            }
            this.operandTypeChanged();
        }

        private setIntConstantValue(intValue: number): void {
            this.getOperand().treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
            this.getOperand().treeItem.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
            this.getOperand().treeItem.constantValue.integerValue = intValue;
            this.getOperand().treeItem.constantValue.decimalValue = undefined;
            this.getOperand().treeItem.constantValue.stringValue = undefined;
        }

        private setDecimalConstantValue(decimalValue: number): void {
            this.getOperand().treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
            this.getOperand().treeItem.variableType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
            this.getOperand().treeItem.constantValue.integerValue = undefined;
            this.getOperand().treeItem.constantValue.decimalValue = decimalValue;
            this.getOperand().treeItem.constantValue.stringValue = undefined;
        }

        private setStringConstantValue(stringValue: string): void {
            this.getOperand().treeItem.constantValue.variableType = Wars.Domain.Model.Codes.Enums.VariableType.String;
            this.getOperand().treeItem.variableType = Wars.Domain.Model.Codes.Enums.VariableType.String;
            this.getOperand().treeItem.constantValue.integerValue = undefined;
            this.getOperand().treeItem.constantValue.decimalValue = undefined;
            this.getOperand().treeItem.constantValue.stringValue = stringValue;
        }

        private isAnInt(value: any): boolean {
            return Number(value) == value && value % 1 === 0;
        }

        private isAFloat(value: any): boolean {
            return Number(value) == value && value % 1 !== 0;
        }
    }
}

warsApp.registerDirective('OperandDropZoneInput', []);